import React from 'react';

const CollaboratorsSkeleton = () => {
  return (
    <div className="collaborators-page">
      {/* Header with AI Badge */}
      <div className="mb-4">
        <div className="d-flex align-items-center gap-3 mb-2">
          <div className="skeleton skeleton-header" />
          <div className="skeleton skeleton-badge" />
        </div>
      </div>

      {/* Action Bar */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex gap-3">
          <div className="skeleton" style={{ width: '150px', height: '38px', borderRadius: '6px' }} />
        </div>
        <div className="d-flex gap-2">
          <div className="skeleton" style={{ width: '200px', height: '38px', borderRadius: '6px' }} />
          <div className="skeleton" style={{ width: '38px', height: '38px', borderRadius: '6px' }} />
        </div>
      </div>

      {/* Table */}
      <div className="skeleton-table">
        {/* Table Header */}
        <div className="d-flex gap-4 mb-3">
          <div className="skeleton" style={{ width: '25%', height: '24px', borderRadius: '4px' }} />
          <div className="skeleton" style={{ width: '25%', height: '24px', borderRadius: '4px' }} />
          <div className="skeleton" style={{ width: '20%', height: '24px', borderRadius: '4px' }} />
          <div className="skeleton" style={{ width: '15%', height: '24px', borderRadius: '4px' }} />
          <div className="skeleton" style={{ width: '15%', height: '24px', borderRadius: '4px' }} />
        </div>

        {/* Table Rows */}
        {[...Array(5)].map((_, index) => (
          <div key={index} className="d-flex gap-4 mb-3">
            <div className="skeleton" style={{ width: '25%', height: '40px', borderRadius: '6px' }} />
            <div className="skeleton" style={{ width: '25%', height: '40px', borderRadius: '6px' }} />
            <div className="skeleton" style={{ width: '20%', height: '40px', borderRadius: '6px' }} />
            <div className="skeleton" style={{ width: '15%', height: '40px', borderRadius: '6px' }} />
            <div className="skeleton" style={{ width: '15%', height: '40px', borderRadius: '6px' }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollaboratorsSkeleton;
